export default "__VITE_ASSET__B1s51BvZ__"